import dispatchPresenceUpdateFromHeader from '../../presenceManager/dispatchPresenceUpdateFromHeader';
import type InstantMessagePresenceType from 'owa-service/lib/contract/InstantMessagePresenceType';
import signInIM from './signInIM';
import type { IO365ShellShim } from '@suiteux/suiteux-shell';

export default function initializeUcwa() {
    signInIM(false /*isUserExplicitSignIn*/);

    const o365shell: IO365ShellShim = (window as any).O365Shell;
    if (o365shell?.MeControl?.SubscribeToPresenceStatus) {
        o365shell.MeControl.SubscribeToPresenceStatus((key: string) => {
            dispatchPresenceUpdateFromHeader(key as InstantMessagePresenceType);
        });
    }
}
